// dispatchers
import { userConfigDispatcher } from '@aceroll/core';

// other
import { dispatcher, platform, serverData, StateController } from '@aceroll/core';


class SpinStartController extends StateController {
    constructor() {
        super("spin.start");
    }

    async onStart() {
        const slotMachine = dispatcher.app.layout.slotMachine;

        slotMachine.spin();

        userConfigDispatcher.subscribeSlamStop();

        const data = await platform.onceBetResponse();

        // serverData.setBetResponse();
        serverData.updateBetServerData(data);
        //due to the documentation the betAcknowledged should be called for non-bonus rounds
        const isRegularRound = !serverData.hasBonus();
        const isRoundStarted = serverData.isRoundValid();

        if (isRoundStarted && isRegularRound) {
            platform.setBetAcknowledged();
        }

        if (isRoundStarted) {
            platform.setGameRoundStarted();
        }


        this.stop();
    }

    onStop() { }
}

export default SpinStartController;